import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** P = V·I·PF (1φ) / √3·V·I·PF (3φ) — circuit + V, A, W meters with PF triangle. */
export function DiagramPowerCalculations() {
  const lx = 70, ly = 75, lw = 220, lh = 110;

  return (
    <DiagramCanvas>
      {/* Loop wires */}
      <Line x1={lx} y1={ly} x2={lx + lw} y2={ly} stroke={DT.stroke} strokeWidth="1.8" />
      <Line x1={lx} y1={ly + lh} x2={lx + lw} y2={ly + lh} stroke={DT.stroke} strokeWidth="1.8" />
      <Line x1={lx} y1={ly} x2={lx} y2={ly + lh} stroke={DT.stroke} strokeWidth="1.8" />
      <Line x1={lx + lw} y1={ly} x2={lx + lw} y2={ly + lh / 2 - 22} stroke={DT.stroke} strokeWidth="1.8" />
      <Line x1={lx + lw} y1={ly + lh / 2 + 22} x2={lx + lw} y2={ly + lh} stroke={DT.stroke} strokeWidth="1.8" />

      {/* Source */}
      <Line x1={lx - 12} y1={ly + lh / 2 - 8} x2={lx + 12} y2={ly + lh / 2 - 8} stroke={DT.stroke} strokeWidth="3" />
      <Line x1={lx - 6} y1={ly + lh / 2 + 4} x2={lx + 6} y2={ly + lh / 2 + 4} stroke={DT.stroke} strokeWidth="2" />

      {/* Voltmeter (parallel to source) */}
      <Circle cx={lx - 30} cy={ly + lh / 2} r={11} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.4" />
      <SvgText x={lx - 30} y={ly + lh / 2 + 4} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">V</SvgText>
      <Line x1={lx - 18} y1={ly + lh / 2 - 8} x2={lx - 30} y2={ly + lh / 2 - 11} stroke={DT.leader} strokeWidth="0.8" />
      <Line x1={lx - 18} y1={ly + lh / 2 + 4} x2={lx - 30} y2={ly + lh / 2 + 11} stroke={DT.leader} strokeWidth="0.8" />

      {/* Ammeter in series (top wire) */}
      <Circle cx={lx + 60} cy={ly} r={11} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.4" />
      <SvgText x={lx + 60} y={ly + 4} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">A</SvgText>

      {/* Wattmeter (with both V and I sensing) */}
      <Circle cx={lx + 140} cy={ly + lh / 2} r={16} fill={DT.fill} stroke={DT.varColor} strokeWidth="1.6" strokeDasharray="3,2" />
      <SvgText x={lx + 140} y={ly + lh / 2 + 4} fill={DT.varColor} fontSize="11" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">W</SvgText>

      {/* Load */}
      <Rect x={lx + lw - 12} y={ly + lh / 2 - 22} width={24} height={44} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.6" />
      <SvgText x={lx + lw} y={ly + lh / 2 + 4} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">LOAD</SvgText>

      {/* PF triangle (top right) */}
      <G>
        <SvgText x={300} y={45} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">PF triangle</SvgText>
        <Polygon points="262,72 322,72 322,42" fill="none" stroke={DT.varColor} strokeWidth="1.4" />
        <SvgText x={290} y={82} fill={DT.varColor} fontSize="8" fontFamily={DT.mono} textAnchor="middle">P (kW)</SvgText>
        <SvgText x={328} y={60} fill={DT.varColor} fontSize="8" fontFamily={DT.mono}>Q</SvgText>
        <SvgText x={278} y={62} fill={DT.varColor} fontSize="8" fontFamily={DT.mono}>S</SvgText>
        <SvgText x={272} y={70} fill={DT.desc} fontSize="7" fontFamily={DT.mono}>θ</SvgText>
      </G>

      {/* Labels */}
      <LeaderLine x1={lx - 30} y1={ly + lh / 2 - 12} x2={20} y2={50} varName="V" desc="Volts" anchor="start" />
      <LeaderLine x1={lx + 60} y1={ly - 12} x2={150} y2={210} varName="I" desc="Amps" anchor="middle" />
      <LeaderLine x1={lx + 140} y1={ly + lh / 2 + 18} x2={20} y2={210} varName="W" desc="real power" anchor="start" />
      <LeaderLine x1={290} y1={70} x2={310} y2={210} varName="PF" desc="cos θ" anchor="end" />

      <FormulaTag formula="P = V·I·PF (1φ)    P = √3 · V_LL · I_L · PF (3φ)" />
    </DiagramCanvas>
  );
}
